import {
  OBAddress,
  OBHardwareInfo,
  OBHardwareIPConfig,
  OBScanner,
  OBScannerInfo,
  OBSensorShipping,
} from '../../../../../types';

export type ScannerFormValues = Omit<OBScanner, 'shippingSiteLocation'> &
  Omit<OBAddress, 'id'>;
export type ScannerFormInfoValues = OBScannerInfo;
export type ScannerFormShippingValues = Omit<
  OBSensorShipping,
  'shippingSiteLocation'
> &
  Omit<OBAddress, 'id'>;

export const AWN_202_SCANNER_INFO: OBHardwareInfo = {
  label: 'Scanner 200',
  hardware_key: 'scanner200',
  allotment_key: 'scanner200',
};

export const EMPTY_SCANNER: ScannerFormValues = {
  name: '',
  model: '',
  siteId: '',
  vanilla: false,

  isIPAutoConfig: false,
  ipAddress: '',
  subnetMask: '',
  gateway: '',
  primaryDns: '',
  secondaryDns: '',

  isShippingToNewSite: false,
  shippingSiteId: '',
  country: '',
  street: '',
  street2: '',
  city: '',
  region: '',
  postcode: '',

  isShippingToNewContact: false,
  shippingContactId: '',
  shippingContactFirstName: '',
  shippingContactLastName: '',
  shippingContactEmail: '',
  shippingContactPhoneNumber: '',
  shippingContactPhoneType: 'office',

  shippingNotes: '',
  configurationTaskID: 0,
};

export const getScannerModelFromFormValues = (
  values: ScannerFormValues,
): OBScanner => {
  const { country, street, street2, city, region, postcode, ...restScanner } =
    values;
  return {
    ...restScanner,
    shippingSiteLocation: {
      id: values.isShippingToNewSite ? '' : values.shippingSiteId,
      country,
      street,
      street2,
      city,
      region,
      postcode,
    },
    ipAddress: values.ipAddress.trim(),
    subnetMask: values.subnetMask.trim(),
    gateway: values.gateway.trim(),
  };
};

export const getFormValues = (scanner: OBScanner): ScannerFormValues => ({
  name: scanner.name,
  model: scanner.model,
  siteId: scanner.siteId,

  isIPAutoConfig: scanner.isIPAutoConfig,
  ipAddress: scanner.ipAddress,
  subnetMask: scanner.subnetMask,
  gateway: scanner.gateway,
  primaryDns: scanner.primaryDns,
  secondaryDns: scanner.secondaryDns,

  isShippingToNewSite: scanner.shippingSiteLocation.id === '' || false,
  shippingSiteId: scanner.shippingSiteLocation.id,
  country: scanner.shippingSiteLocation.country,
  street: scanner.shippingSiteLocation.street,
  street2: scanner.shippingSiteLocation.street2,
  city: scanner.shippingSiteLocation.city,
  region: scanner.shippingSiteLocation.region,
  postcode: scanner.shippingSiteLocation.postcode,

  isShippingToNewContact: scanner.isShippingToNewContact,
  shippingContactId: scanner.shippingContactId,
  shippingContactFirstName: scanner.shippingContactFirstName,
  shippingContactLastName: scanner.shippingContactLastName,
  shippingContactEmail: scanner.shippingContactEmail,
  shippingContactPhoneNumber: scanner.shippingContactPhoneNumber,
  shippingContactPhoneType: scanner.shippingContactPhoneType,

  shippingNotes: scanner.shippingNotes,
  vanilla: scanner.vanilla,
  configurationTaskID: scanner.configurationTaskID,
});

export const getScannerInfoValues = (
  scanner: ScannerFormValues,
): ScannerFormInfoValues => ({
  name: scanner.name,
  model: scanner.model,
  siteId: scanner.siteId,
  vanilla: scanner.vanilla,
  configurationTaskID: scanner.configurationTaskID,
});

export const getScannerNetworkValues = (
  scanner: ScannerFormValues,
): OBHardwareIPConfig => ({
  isIPAutoConfig: scanner.isIPAutoConfig,
  ipAddress: scanner.ipAddress,
  subnetMask: scanner.subnetMask,
  gateway: scanner.gateway,
  primaryDns: scanner.primaryDns,
  secondaryDns: scanner.secondaryDns,
});

export const getScannerShippingValues = (
  sensor: ScannerFormValues,
): ScannerFormShippingValues => ({
  isShippingToNewSite: sensor.isShippingToNewSite,
  shippingSiteId: sensor.shippingSiteId,
  country: sensor.country,
  street: sensor.street,
  street2: sensor.street2,
  city: sensor.city,
  region: sensor.region,
  postcode: sensor.postcode,

  isShippingToNewContact: sensor.isShippingToNewContact,
  shippingContactId: sensor.shippingContactId,
  shippingContactFirstName: sensor.shippingContactFirstName,
  shippingContactLastName: sensor.shippingContactLastName,
  shippingContactEmail: sensor.shippingContactEmail,
  shippingContactPhoneNumber: sensor.shippingContactPhoneNumber,
  shippingContactPhoneType: sensor.shippingContactPhoneType,

  shippingNotes: sensor.shippingNotes,
});
